// Keyed by the step names from `composeSteps` in `../utils`.
export const STEP_COPY = {
  'Participant Information': {
    label: 'Participants',
    title: "Who's coming?",
  },
  'Review & Pay': {
    label: 'Review & pay',
    title: 'Review & pay',
  },
  Waiver: {
    label: 'Waiver',
    title: 'Sign the waiver',
  },
}
